<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
            <app-select label="Method" placeholder="Choose..." [items]="methodItems" [saveValue]="true" formControlName="method"></app-select>
            <app-text-input label="Area" placeholder="Text..." formControlName="area" inputMode="text"></app-text-input>
            <app-text-input label="Time kept on" placeholder="Text..." formControlName="timeKeptOn"></app-text-input>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
    </div>
</app-action-form>